import lazyLoading from './lazyLoading.js'

export default {
  name: 'visits',
  meta: {
    title: 'Visits',
    iconClass: 'vuestic-icon vuestic-icon-graph'
  },
  path: '/visits',
  component: lazyLoading('visits/Visits')
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/visits.js